import { BridgeCard } from 'src/components/Onboarding/BridgePanel';
import { BRIDGE_OPTIONS } from 'src/constants/constants';

const BridgeTab = ({ onClose }: { onClose: () => void }) => {
	return (
		<div className="flex flex-col gap-3">
			{BRIDGE_OPTIONS.map((bridgeOption) => (
				<span onClick={onClose} key={bridgeOption.bridge}>
					<BridgeCard
						imageUrl={bridgeOption.imageUrl}
						title={bridgeOption.title}
						description={bridgeOption.description}
						route={bridgeOption.route}
						bridge={bridgeOption.bridge}
					/>
				</span>
			))}
		</div>
	);
};

export default BridgeTab;
